import { FC } from "react";
import { t } from "@lingui/macro";
import { Flex } from "@otrium/core";
import { connectStats } from "react-instantsearch-dom";
import { StatsProvided } from "react-instantsearch-core";
import { ResultsButton } from "./DesktopFilter.styled";
import { useLingui } from "@lingui/react";

interface Props extends StatsProvided {
  hasFilters: boolean;
  onClick: () => void;
}

const ShowResultsComponent: FC<Props> = ({
  nbHits: total,
  hasFilters,
  onClick,
}) => {
  const { i18n } = useLingui();

  return (
    <Flex variant="centered">
      <ResultsButton
        fullWidth
        data-testid="filter-show-results-btn"
        variant="primary"
        disabled={!hasFilters}
        onClick={onClick}
      >
        <span>
          {hasFilters ? t(i18n)`Show ${total} results` : t(i18n)`Show results`}
        </span>
      </ResultsButton>
    </Flex>
  );
};

const ShowResults = connectStats(ShowResultsComponent);

export { ShowResults };
